module.exports = __webpack_public_path__ + "media/images/arrow-right-button-dark-774b5fde0bfabab1a06d5a7421721a9f.svg";